"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ShipmentTicketDetailStyles = require("../../styles/ShipmentTicketDetailStyles");

var _ShipmentDetailDialogStyles = require("../../styles/ShipmentDetailDialogStyles");

var _OrbitNetStyles = require("../../styles/OrbitNetStyles");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _ShipmentCardStyles = require("../../styles/ShipmentCardStyles");

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ShipmentTicketDetail = function ShipmentTicketDetail(_ref) {
  var tickets = _ref.tickets,
      order = _ref.order,
      detailButton = _ref.detailButton,
      onChange = _ref.onChange,
      icon = _ref.icon;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      getTicket = _useState2[0],
      setTicket = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      getPosition = _useState4[0],
      setPosition = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      getTimeSelected = _useState6[0],
      setTimeSelected = _useState6[1];

  var scrollRef = /*#__PURE__*/(0, _react.createRef)();
  var tab = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    if (tickets.length > 0) {
      if (order && order.id) {
        var t = tickets.find(function (ticket) {
          return ticket.id === order.id;
        });
        setTicket(t);
        setTimeSelected(order.op === 'load' ? t.origin : t.destination);
      } else {
        setTicket(tickets[0]);
      }
    }

    setPosition(0);
  }, [tickets]);

  var getEtaLoading = function getEtaLoading(order_containers, appointment) {
    var timesToShow = [];
    (order_containers || []).map(function (container) {
      var _container$ata_loadin, _container$eta_loadin;

      var ataDate = (_container$ata_loadin = container === null || container === void 0 ? void 0 : container.ata_loading) !== null && _container$ata_loadin !== void 0 ? _container$ata_loadin : '';
      var etaDate = (_container$eta_loadin = container === null || container === void 0 ? void 0 : container.eta_loading) !== null && _container$eta_loadin !== void 0 ? _container$eta_loadin : '';
      var timeToValidate = ataDate === '' ? etaDate : ataDate;
      var isEta = ataDate === '';

      if (timeToValidate === '') {
        timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, 'ETA: No disponible '));
      } else {
        var isRedColor = false;

        if (appointment !== '') {
          isRedColor = (0, _moment["default"])(timeToValidate).isSameOrAfter(appointment);
        }

        if (isRedColor) {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAlate, null, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        } else {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAlow, null, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        }
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, timesToShow);
  };

  var getEtaUnloading = function getEtaUnloading(order_containers, appointment) {
    var timesToShow = [];
    (order_containers || []).map(function (container) {
      var _container$ata_unload, _container$eta_unload;

      var ataDate = (_container$ata_unload = container === null || container === void 0 ? void 0 : container.ata_unloading) !== null && _container$ata_unload !== void 0 ? _container$ata_unload : '';
      var etaDate = (_container$eta_unload = container === null || container === void 0 ? void 0 : container.eta_unloading) !== null && _container$eta_unload !== void 0 ? _container$eta_unload : '';
      var timeToValidate = ataDate === '' ? etaDate : ataDate;
      var isEta = ataDate === '';

      if (timeToValidate === '') {
        timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, 'ETA: No disponible '));
      } else {
        var isRedColor = false;

        if (appointment !== '') {
          isRedColor = (0, _moment["default"])(timeToValidate).isSameOrAfter(appointment);
        }

        if (isRedColor) {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAlate, null, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        } else {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETADescription, null, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAlow, null, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        }
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, timesToShow);
  };

  return /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.FolioWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.FolioTitle, null, "Folios"), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.FolioOptionsWrapper, null, tickets.map(function (ticket) {
    return /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.FolioOption, {
      isActive: getTicket && ticket.id === getTicket.id,
      onClick: function onClick() {
        setTicket(ticket);
        onChange(ticket);
      },
      key: ticket.number
    }, ticket.number);
  }))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.InfoWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.ContainerLevelShipment, {
    position: "absolute",
    right: "1rem",
    top: "0rem"
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.TitleLevelShipment, {
    color: "black"
  }, "Nivel"), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.NumberLevelShipment, {
    background: "#B7C5E3",
    color: "white"
  }, getTicket && (getTicket.level || '')), /*#__PURE__*/_react["default"].createElement("div", null, getTicket && (getTicket.detailButton || ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.LogosWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoFigure, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoImg, {
    src: getTicket ? getTicket.origin.companyLogo : ''
  })), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoFigure, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoImg, {
    src: getTicket ? getTicket.destination.companyLogo : ''
  }))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ArrowWrapper, null), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.LocationWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: "".concat((getTicket === null || getTicket === void 0 ? void 0 : getTicket.id) || '', "-origin"),
    "aria-haspopup": "true",
    place: "right"
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, getEtaLoading((getTicket === null || getTicket === void 0 ? void 0 : getTicket.containers) || [], (getTicket === null || getTicket === void 0 ? void 0 : getTicket.origin.timedate) || ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.LocationSubWrapper, {
    border: getTicket && getTimeSelected && getTicket.origin.location === getTimeSelected.location && getTicket.origin.timedate === getTimeSelected.timedate ? "3px solid #337dec" : ""
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.Title, {
    align: "center"
  }, getTicket ? getTicket.origin.location : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, {
    "data-tip": true,
    "data-for": "".concat((getTicket === null || getTicket === void 0 ? void 0 : getTicket.id) || '', "-origin")
  }, getTicket ? getTicket.origin.timedate : '')), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: "".concat((getTicket === null || getTicket === void 0 ? void 0 : getTicket.id) || '', "-destiny"),
    "aria-haspopup": "true",
    place: "right"
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, getEtaUnloading((getTicket === null || getTicket === void 0 ? void 0 : getTicket.containers) || [], (getTicket === null || getTicket === void 0 ? void 0 : getTicket.destination.timedate) || ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.LocationSubWrapper, {
    border: getTicket && getTimeSelected && getTicket.destination.location === getTimeSelected.location && getTicket.destination.timedate === getTimeSelected.timedate ? "3px solid #337dec" : ""
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.Title, {
    align: "center"
  }, getTicket ? getTicket.destination.location : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, {
    "data-tip": true,
    "data-for": "".concat((getTicket === null || getTicket === void 0 ? void 0 : getTicket.id) || '', "-destiny")
  }, getTicket ? getTicket.destination.timedate : ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ExtraDataWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, {
    marginLeft: "0",
    marginRight: "1.2rem"
  }, getTicket ? getTicket.weightIcon : '', getTicket ? getTicket.weight : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, {
    marginLeft: "0",
    marginRight: "1.2rem"
  }, getTicket ? getTicket.volumeIcon : '', getTicket ? getTicket.volume : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, {
    marginLeft: "0",
    marginRight: "1.2rem"
  }, getTicket ? getTicket.capacityIcon : '', getTicket ? getTicket.capacity : ''))), getTicket && getTicket.status && getTicket.status.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TabsWrapper, {
    ref: scrollRef
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.Tab, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.StatusWrapper, null, getTicket && getTicket.status ? getTicket.status.map(function (status) {
    return /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.WrapperLabel, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TripStatus, null, /*#__PURE__*/_react["default"].createElement("div", null, status.icon, status.trailer), status.name));
  }) : '')), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.Tab, {
    ref: tab
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TagsWrapper, null, getTicket ? getTicket.tags.map(function (tag) {
    return /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.LabelColor, {
      background: "#688BCE",
      key: tag.id
    }, tag.description);
  }) : ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TabsControl, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TabButton, {
    isActive: getPosition === 0,
    onClick: function onClick() {
      setPosition(0);
      scrollRef.current.scrollTo(0, 0);
    }
  }), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TabButton, {
    isActive: getPosition === 1,
    onClick: function onClick() {
      setPosition(1);
      scrollRef.current.scrollTo(tab.current.clientWidth, 0);
    }
  }))) : /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.TagsWrapper, null, getTicket ? getTicket.tags.map(function (tag) {
    return /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.LabelColor, {
      background: "#688BCE",
      key: tag.id
    }, tag.description);
  }) : ''));
};

var _default = ShipmentTicketDetail;
exports["default"] = _default;